module.exports = __webpack_public_path__ + "assets/img/box_no.484887e8.svg";